import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './CloseCircleIcon.c.svg';

export const CloseCircleIcon = withIconWrapper(ReactComponent);
